import React, {FC} from "react";
import {useSnackBar} from "./hooks/useSnackBar";

export const Snack: FC = () => {
  useSnackBar();
  return (
    <></>
  )
};
